import { render, staticRenderFns } from "./insActivityLog.vue?vue&type=template&id=6e2cc06b&"
import script from "./insActivityLog.vue?vue&type=script&lang=js&"
export * from "./insActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports